// extracted by mini-css-extract-plugin
module.exports = {"socialShare":"styles_socialShare__fc8gE","icon":"styles_icon__j4SHJ","collapsed":"styles_collapsed__1P_bV","header":"styles_header__3qxTx"};